<template>
  <div class="couponData" style="background: #f0f2f5">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>活动</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/couponList' }">优惠券列表</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券数据</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 商城订单 项目订单 快捷操作 会员数据概况 -->
    <div class="topSquare boxLayout mg-b-10">
      <h3 class="title-t mg-b-10">使用数据</h3>
      <div class="analysis flex space-start">
        <div class="text-center">
          <h6 class="font-12 color-999">已领用人数</h6>
          <p class="font-30">{{ tableData.total_num }}</p>
        </div>
        <div class="text-center" style="margin-left: 12px">
          <h6 class="font-12 color-999">已使用人数</h6>
          <p class="font-30">{{ tableData.used_num }}</p>
        </div>
      </div>
    </div>
    <div class="topSquare boxLayout">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="手机号" class="mobile">
          <el-input size="medium" placeholder="请输入手机号" v-model="searchForm.mobile"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="getList">查询</el-button>
          <el-button size="medium" @click="clear">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData.list" style="width: 100%" border v-loading="loading" :cell-style="{ padding: '0' }">
        <el-table-column prop="nick_name" label="用户昵称" sortable align="center"> </el-table-column>
        <el-table-column prop="real_name" label="真实姓名" sortable align="center"> </el-table-column>
        <el-table-column prop="mobile" label="手机号" sortable align="center"> </el-table-column>
        <el-table-column prop="create_time" label="领用(发放)时间" sortable align="center"> </el-table-column>
        <el-table-column prop="release_type" label="来源" sortable align="center"> </el-table-column>
        <el-table-column prop="status" label="状态" sortable align="center"> </el-table-column>
        <el-table-column prop="give_nick_name" label="转赠人" sortable align="center"> </el-table-column>
        <el-table-column prop="give_mobile" label="转赠手机" sortable align="center"> </el-table-column>
        <!-- <el-table-column prop="give_status" label="转赠状态" sortable align="center"> </el-table-column> -->
        <!-- <el-table-column prop="transfer_direction" label="转赠人信息" sortable align="center"> </el-table-column> -->
        <el-table-column prop="order_sn" label="关联订单" sortable align="center"> </el-table-column>
        <el-table-column prop="expire_time" label="过期时间" align="center"> </el-table-column>
        <el-table-column label="操作" :align="'center'" fixed="right" width="60px">
          <template slot-scope="scope">
            <el-button type="text" @click="onCancel(scope.row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :page_size="tableData.page_size"
        :page_index="tableData.page_index"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
  import pagination from "../../../components/pagination.vue";

  export default {
    name: "couponData",
    components: {
      pagination,
    },
    data() {
      return {
        loading: false,
        searchForm: {},
        tableData: {
          list: [],
          page_size: 10,
          page_index: 1,
          total: 0,
          used_num: 0,
          total_num: 0,
        },
      };
    },
    created() {
      this.getList();
    },
    methods: {
      requestApi(path, method, data = {}) {
        this.loading = true;
        return this.axios({
          method: method || "get", //请求方法
          data,
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Coupon/${path}`,
        })
          .then((res) => res.data.result)
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
            return Promise.reject(err.response.data);
          })
          .finally(() => (this.loading = false));
      },
      getList() {
        const path = `datalist/${this.$route.query.uuid}?mobile=${this.searchForm.mobile || ""}`;
        this.requestApi(path).then((res) => {
          this.tableData = res;
        });
      },
      clear() {
        for (let i in this.searchForm) {
          this.searchForm[i] = "";
        }
        this.getList();
      },
      onCancel(row) {
        this.$confirm("确定该优惠券作废?", "作废确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const params = {
            uuid: row.coupon_record_uuid,
          };
          this.requestApi("invalidate", "post", params).then((res) => {
            this.$message({ type: "success", message: "操作成功!" });
            this.getList();
          });
        });
      },
      handleSizeChange(v) {
        this.tableData.page_size = v;
        this.getList();
      },
      handleCurrentChange(v) {
        this.tableData.page_index = v;
        this.getList();
      },
    },
  };
</script>
<style scoped></style>
